<!--
 * @Description: 楼盘
 * @Author: 琢磨先生
 * @Date: 2023-02-18 21:33:47
 * @LastEditors: cts 308360781@qq.com
 * @LastEditTime: 2025-07-09 17:07:45
-->
<template>
  <el-card class="box query">
    <el-form :model="query" ref="query" :inline="true">
      <el-form-item label="名称">
        <el-input
          v-model="query.q"
          placeholder="请输入楼盘名称"
          clearable
          style="width: 300px"
        ></el-input>
      </el-form-item>
      <el-form-item label="状态">
        <el-select
          v-model="query.status"
          placeholder
          clearable
          style="width: 120px"
        >
          <el-option
            :label="item.label"
            :value="item.value"
            v-for="item in enums.estate_status"
            :key="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="代理类型">
        <el-select
          v-model="query.type"
          placeholder
          clearable
          style="width: 120px"
        >
          <el-option
            :label="item.label"
            :value="item.value"
            v-for="item in enums.estate_types"
            :key="item.value"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="隐藏客户手机">
        <el-select
          v-model="query.isHiddenMobile"
          placeholder=""
          clearable
          style="width: 120px"
        >
          <el-option label="是" :value="true"></el-option>
          <el-option label="否" :value="false"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="自定义公司">
        <el-select
          v-model="query.isHiddenCompany"
          placeholder=""
          clearable
          style="width: 120px"
        >
          <el-option label="是" :value="true"></el-option>
          <el-option label="否" :value="false"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="有二维码">
        <el-select
          v-model="query.isGetQRCode"
          placeholder=""
          clearable
          style="width: 120px"
        >
          <el-option label="是" :value="true"></el-option>
          <el-option label="否" :value="false"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="购房资格">
        <el-select
          v-model="query.isQualification"
          placeholder=""
          clearable
          style="width: 120px"
        >
          <el-option label="是" :value="true"></el-option>
          <el-option label="否" :value="false"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="详情下架">
        <el-select
          v-model="query.isSoldOut"
          placeholder=""
          clearable
          style="width: 120px"
        >
          <el-option label="是" :value="true"></el-option>
          <el-option label="否" :value="false"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="隐藏带看人手机">
        <el-select
          v-model="query.isHideDaikanMobile4"
          placeholder=""
          clearable
          style="width: 120px"
        >
          <el-option label="是" :value="true"></el-option>
          <el-option label="否" :value="false"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="全号报备">
        <el-select
          v-model="query.isFullNumber"
          placeholder=""
          clearable
          style="width: 120px"
        >
          <el-option label="是" :value="true"></el-option>
          <el-option label="否" :value="false"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="开启直连明源">
        <el-select
          v-model="query.isLinkYunke"
          placeholder=""
          clearable
          style="width: 120px"
        >
          <el-option label="是" :value="true"></el-option>
          <el-option label="否" :value="false"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="已配置明源">
        <el-select
          v-model="query.isYunkeCfg"
          placeholder=""
          clearable
          style="width: 120px"
        >
          <el-option label="是" :value="true"></el-option>
          <el-option label="否" :value="false"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" round @click="onSearch" icon="search"
          >查询</el-button
        >
      </el-form-item>
      <el-form-item label="">
        <el-button
          type="success"
          round
          :loading="createIndexLoading"
          @click="onCreateIndex"
          >创建索引</el-button
        >
        <el-tooltip
          class="box-item"
          effect="dark"
          content="下载查询结果数据"
          placement="top"
        >
          <el-button
            icon="Download"
            round
            v-power="'admin/v1/estate/export_excel'"
            @click="downloadExcel"
            :loading="downloading"
            >下载数据</el-button
          >
        </el-tooltip>
      </el-form-item>
    </el-form>
  </el-card>

  <el-card class="box data" v-loading="loading">
    <el-table
      ref="table"
      :data="tableData.data"
      border
      stripe
      @sort-change="onSort"
    >
      <el-table-column
        label="ID"
        prop="id"
        width="80"
        fixed="left"
      ></el-table-column>
      <el-table-column
        label="名称"
        prop="name"
        fixed="left"
        width="200"
        :resizable="false"
      ></el-table-column>
      <el-table-column
        label="类型"
        prop="typeText"
        width="100"
      ></el-table-column>
      <el-table-column
        label="分部"
        prop="attributeName"
        width="100"
      ></el-table-column>
      <el-table-column label="市县/自定义区域" prop="areaName" width="340">
        <template #default="scope">
          <div>{{ scope.row.areaName }}</div>
          <div>{{ scope.row.udfAreaName }}</div>
        </template>
      </el-table-column>
      <el-table-column label="状态" width="100">
        <template #default="scope">
          <el-tag
            type="success"
            size="small"
            v-if="scope.row.stopStatus == 0"
            >{{ scope.row.stopStatusText }}</el-tag
          >
          <el-tag
            type="danger"
            size="small"
            v-else-if="scope.row.stopStatus == 2 || scope.row.stopStatus == 3"
            >{{ scope.row.stopStatusText }}</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column label="报备设置" width="200">
        <template #default="scope">
          <span>
            需提前
            <span class="blue"
              >{{ scope.row.aheadHour }}小时{{ scope.row.aheadMin }}分</span
            >
          </span>
          <div>
            <span v-if="scope.row.limitNum">
              限
              <span class="blue">{{ scope.row.limitNum }}</span
              >人报备
            </span>
            <span class="red" v-else>不限人数(任何人可报)</span>
          </div>
          <div>
            <span v-if="scope.row.protectTheDay">
              报备保护只
              <span class="blue">当天有效</span>
            </span>
            <span v-else>
              <span
                class="red"
                v-if="scope.row.protectDays == 0 && scope.row.protectHour == 0"
                >无报备保护期</span
              >
              <span
                v-if="scope.row.protectDays != 0 || scope.row.protectHour != 0"
              >
                报备保护期
                <span class="blue"
                  >{{ scope.row.protectDays }}天{{
                    scope.row.protectHour
                  }}小时</span
                >
              </span>
            </span>
          </div>
          <div>
            <span v-if="scope.row.dkSecureDays">
              带看保护
              <span class="blue">{{ scope.row.dkSecureDays }}天</span>
            </span>
            <span v-else class="red">无带看保护期</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="自定义公司名称" width="200">
        <template #default="scope">
          <div v-if="scope.row.isHiddenCompany">
            是
            <span class="blue"
              >(替换公司:{{
                scope.row.copyCompanyName
                  ? scope.row.copyCompanyName
                  : "三亚德佑房地产投资服务有限公司"
              }})</span
            >
          </div>
          <div v-else-if="scope.row.companyPrefix">
            分销前缀(
            <span class="blue">{{ scope.row.companyPrefix }}</span
            >)
          </div>
        </template>
      </el-table-column>
      <el-table-column label="全号报备" width="100">
        <template #default="scope">
          <el-tag size="small" v-if="scope.row.isFullNumber"> 全号报备 </el-tag>
          <span v-if="!scope.row.isFullNumber">否</span>
        </template>
      </el-table-column>
      <el-table-column label="序号" prop="orderNum" width="100" sortable>
      </el-table-column>
      <el-table-column label="隐藏客户手机号" width="150">
        <template #default="scope">
          <div v-if="scope.row.isHiddenMobile">
            是
            <span class="blue">(隐藏中间{{ scope.row.hiddenNum }}位)</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="复制性别" width="100">
        <template #default="scope">
          <div v-if="scope.row.copySex">是</div>
        </template>
      </el-table-column>
      <el-table-column label="有带看单" width="100">
        <template #default="scope">
          <div v-if="scope.row.isUpDKTicket">是</div>
        </template>
      </el-table-column>
      <el-table-column label="需到案确认" width="100">
        <template #default="scope">
          <div v-if="scope.row.isYBConfirm">是</div>
        </template>
      </el-table-column>

      <el-table-column label="开启二维码" width="140">
        <template #default="scope">
          <div v-if="scope.row.isGetQRCode">
            是
            <span class="blue" v-if="scope.row.needReqQRCode"
              >(需手动获取)</span
            >
            {{
              scope.row.qrAfterMinutes
                ? `、获取间隔${scope.row.qrAfterMinutes}分钟`
                : ""
            }}
            {{
              scope.row.qrBeforeHouse
                ? `、报备${scope.row.qrBeforeHouse}小时后拒绝获取`
                : ""
            }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="需购房资格" width="100">
        <template #default="scope">
          <div v-if="scope.row.isQualification">是</div>
        </template>
      </el-table-column>
      <el-table-column label="详情下架" width="100">
        <template #default="scope">
          <span class="red" v-if="scope.row.isSoldOut">是</span>
        </template>
      </el-table-column>
      <el-table-column
        label="佣金点位"
        prop="fxPolicy"
        min-width="400"
      ></el-table-column>
      <el-table-column
        label="报备说明"
        prop="tuijianDesc"
        min-width="300"
      ></el-table-column>
      <el-table-column label="价格区间" width="200">
        <template #default="{ row }">
          <span v-if="row.beginTotalAmount"
            >{{ row.beginTotalAmount }} ~ {{ row.endTotalAmount }}万</span
          >
          <span v-else>--</span>
        </template>
      </el-table-column>
      <el-table-column
        label="搜索关键字"
        prop="elasticKeywords"
        width="200"
      ></el-table-column>
      <el-table-column label="房产网" width="200">
        <template #default="{ row }">
          <div>ID：{{ row.fwwIntId }}</div>
          <div>名称：{{ row.fwwName }}</div>
        </template>
      </el-table-column>
      <el-table-column label="直连明源/自动推送" width="100" :resizable="false">
        <template #default="scope">
          <el-tag type="success" v-if="scope.row.isLinkYunke">是</el-tag>
          <el-text v-if="!scope.row.isLinkYunke">否</el-text>
          <div>
            <el-link
              type="primary"
              :underline="false"
              v-if="scope.row.isAutoPushYunke"
              >自动推送</el-link
            >
            <el-link
              type="default"
              :underline="false"
              v-if="!scope.row.isAutoPushYunke"
              >手动推送</el-link
            >
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="明源归属手机"
        width="140"
        prop="yunkeResidentTel"
        :resizable="false"
      >
      </el-table-column>
      <el-table-column label="明源项目创建" width="240">
        <template #default="{ row }">
          <div>
            状态：
            <el-link :underline="false" v-if="row.yunkePushStatus == 0"
              >无</el-link
            >
            <el-link
              type="primary"
              :underline="false"
              v-if="row.yunkePushStatus == 5"
              >推送中...</el-link
            >
            <el-link
              type="success"
              :underline="false"
              v-if="row.yunkePushStatus == 10"
              >成功</el-link
            >
            <el-link
              type="danger"
              :underline="false"
              v-if="row.yunkePushStatus == 20"
              >失败</el-link
            >
          </div>
          <el-text>推送时间：{{ row.yunkePushAt ?? "无" }}</el-text>
          <div>
            <el-text>结果描述：{{ row.yunkePushMessage ?? "无" }}</el-text>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="创建时间"
        width="200"
        prop="creationTime"
      ></el-table-column>
      <el-table-column label="操作" width="150" fixed="right">
        <template #default="scope">
          <el-button
            type="primary"
            link
            size="small"
            @click="onEdit(scope.row)"
            icon="edit"
            v-if="is_can_edit"
            >修改</el-button
          >
          <el-button
            type="primary"
            link
            size="small"
            @click="onUpdateYunke(scope.row)"
            icon="edit"
            v-if="is_can_edit"
            >配置明源直连</el-button
          >
          <el-button
            type="warning"
            link
            size="small"
            @click="onYunkeCustomField(scope.row)"
            icon="edit"
            v-if="is_can_edit && scope.row.yunkeProjId"
            >明源自定义字段</el-button
          >

          <el-popconfirm
            width="220"
            v-if="is_can_del"
            :title="`您确定要删除【${scope.row.name}】？`"
            @confirm="onDelete(scope.row)"
          >
            <template #reference>
              <el-button
                size="small"
                type="danger"
                link
                icon="delete"
                :loading="scope.row.deleting"
                >删除</el-button
              >
            </template>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="pageSizeChange"
      @current-change="pageCurrentChange"
      :current-page="query.pageIndex"
      :page-sizes="[20, 40, 60, 80, 100]"
      :page-size="query.pageSize"
      layout="total, sizes, prev, pager, next"
      :total="tableData.counts"
    ></el-pagination>
  </el-card>
  <edit-loupan
    :id="edit_id"
    @closed="edit_id = null"
    @success="loadData"
  ></edit-loupan>
  <update-yunke
    :id="edit_yunke_id"
    @closed="edit_yunke_id = null"
    @success="loadData"
  ></update-yunke>
  <custom-field
    :item="current_field_item"
    @closed="current_field_item = null"
    @success="loadData"
  ></custom-field>
</template>

<script>
import common_api from "@/http/common_api";
import EditLoupan from "./edit_loupan.vue";
import fileDownload from "js-file-download";
import UpdateYunke from "./update_yunke.vue";
import CustomField from "./custom_field.vue";
export default {
  components: {
    EditLoupan,
    UpdateYunke,
    CustomField,
  },
  data() {
    return {
      loading: false,
      createIndexLoading: false,
      downloading: false,
      query: {
        pageIndex: 1,
        pageSize: 20,
        order: {
          sort: "",
          fieldName: "",
        },
        q: "",
      },
      enums: {},
      tableData: {
        counts: 0,
      },
      edit_id: null,
      edit_yunke_id: null,
      current_field_item: null,
      is_can_edit: false,
      is_can_del: false,
    };
  },
  created() {
    this.is_can_edit = this.$power("admin/v1/estate/edit");
    this.is_can_del = this.$power("admin/v1/estate/del");
    common_api.get_enums().then((res) => {
      if (res.code == 0) {
        this.enums = res.data;
      }
    });
    this.loadData();
  },
  methods: {
    /**
     * 搜索
     */
    onSearch() {
      this.query.pageIndex = 1;
      this.loadData();
    },
    /**
     * 分页页数更改
     */
    pageSizeChange(val) {
      this.query.pageSize = val;
      this.loadData();
    },

    /**
     * 分页页码更改
     */
    pageCurrentChange(val) {
      this.query.pageIndex = val;
      this.loadData();
    },

    /**
     * 排序
     */
    onSort(e) {
      if (e.prop) {
        this.query.sort = {
          order: e.order,
          prop: e.prop,
        };
        this.loadData();
      }
    },

    /**
     *
     */
    loadData() {
      this.loading = true;
      this.$http
        .post("admin/v1/estate", this.query)
        .then((res) => {
          if (res.code == 0) {
            this.tableData = res.data;
          }
        })
        .finally(() => (this.loading = false));
    },

    /**
     * 创建索引
     */
    onCreateIndex() {
      this.$confirm("您确定要重新创建？", "温馨提醒").then(() => {
        this.createIndexLoading = true;
        this.$http.get("admin/v1/estate/createIndex").then((res) => {
          if (res.code == 0) {
            this.$message.success(res.msg);
          }
          this.createIndexLoading = false;
        });
      });
    },

    /**
     * 修改
     */
    onEdit(item) {
      this.edit_id = item.id;
    },

    /**
     *
     * @param item
     */
    onUpdateYunke(item) {
      this.edit_yunke_id = item.id;
    },

    /**
     *
     * @param item
     */
    onYunkeCustomField(item) {
      this.current_field_item = item;
    },
    /**
     * 删除
     */
    onDelete(item) {
      item.deleting = true;
      this.$http.get(`admin/v1/estate/del?id=${item.id}`).then((res) => {
        if (res.code == 0) {
          this.$message.success(res.msg);
          this.loadData();
        }
      });
    },

    /**
     * 下载数据
     */
    downloadExcel() {
      this.downloading = true;
      var arg = Object.assign({}, this.query);
      delete arg.storeIds;
      if (
        Array.isArray(this.query.storeIds) &&
        this.query.storeIds.length > 0
      ) {
        arg.store_ids = this.query.storeIds.map((x) => {
          return x[1];
        });
      }
      this.$http
        .post("admin/v1/estate/export_excel", arg, {
          responseType: "blob",
        })
        .then((res) => {
          fileDownload(res, "项目.xlsx");
        })
        .finally(() => {
          this.downloading = false;
        });
    },
  },
};
</script>

<style scoped>
/* .blue {
  color: var(--el-color-primary);
}
.red {
  color: var(--el-color-danger);
} */
</style>
